import { useFormik } from "formik";
import { validationSchema } from "../validations/validationsCustomers";

export const useFormRCSCustomers = ({ onSubmit }) => {
  return useFormik({
    initialValues: {
      period: {
        dateFrom: "",
        dateTo: "",
      },
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const dataToSubmit = {
        from: values?.period?.dateFrom,
        to: values?.period.dateTo,
      };

      onSubmit(dataToSubmit);
    },
  });
};
